import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LucideAngularModule } from 'lucide-angular';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { Subscription } from 'rxjs';
import { CartService } from '../../services/cart.service';

@Component({
  selector: 'app-privacypolicy',
  standalone: true,
  imports: [CommonModule,
      FormsModule,
      LucideAngularModule,
      HeaderComponent,
      FooterComponent],
  templateUrl: './privacypolicy.component.html',
  styleUrl: './privacypolicy.component.css'
})
export class PrivacyPolicyComponent {
   cartCount = 0;
    submitted = false;
    openFaq: number | null = null;
    private cartSubscription!: Subscription;
    constructor(private cartService: CartService){

    }
 ngOnInit() {
    this.cartSubscription = this.cartService.cart$.subscribe(() => {
      this.cartCount = this.cartService.getCartCount();
    });
  }
}